// ======================================================================
// File Name       : ReceivedMessageList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, Button, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Dotdotdot from 'react-dotdotdot';
import TableHead from '../../components/TableHead';
import { parseDateForDetail } from '../../utils/index';
import ReduxFormPaging from '../../components/ReduxFormPaging';
import { RECEIVE_MESSAGE_THREAD_DETAIL } from '../../constants/PathConstants';
import PaginationCustom from '../../components/Pagination';
import { RECEIVE_CHAT_DETAIL } from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';
import * as ICON from '../../constants/IconConstants';

const thead = [
  { title: 'スレッドタイトル', sortBy: null },
  { title: '送信者', sortBy: null },
  { title: 'メッセージ', sortBy: null },
  { title: '送信日時', sortBy: 8},
  { title: '操作', sortBy: null},
  { title: '添付ファイル', sortBy: null},
];

class ReceivedMessageList extends React.Component {
  render() {
    const {
      receiveMessages,
      downloadAttachment,
      invalid,
      handleSortState,
      goToDetail,
      getStartEndData,
      recordNum,
      startPosition,
    } = this.props;
    let tbody = null;
    if (receiveMessages && receiveMessages.allMessageIds && receiveMessages.allMessageIds.length) {
      const byMessageIds = receiveMessages.byMessageIds;
      tbody = receiveMessages.allMessageIds.map((messageIdAuto, index) => {
        if (!byMessageIds[messageIdAuto]) {
          return null;
        }
        const {
          messageTitle,
          authorName,
          messageContent,
          createdAt,
          attachmentFileName,
          authorSecernId,
          rootMessageIdAuto,
        } = byMessageIds[messageIdAuto];
        const link = RECEIVE_CHAT_DETAIL.replace(':messageRootId', rootMessageIdAuto).replace(
          ':userSecernId',
          authorSecernId,
        );
        return (
          <tr key={index} onMouseEnter={() => this.props.handleMouseEnter(index)} onMouseLeave={() => this.props.handleMouseLeave()}>
            <td>{messageTitle}</td>
            <td>{authorName}</td>
            <td>
              <Dotdotdot clamp={2}>
                {messageContent}
              </Dotdotdot>
            </td>
            <td style={{ wordBreak: 'break-word' }}>{parseDateForDetail(createdAt)}</td>
            <td className="text-center">
              <CustomLink
                className="margin-right-7 link-detail"
                to={link}
                text="送信"
              />
            </td>
            {attachmentFileName ? (
              <td className="text-center">
                <CustomLink
                  className="btn-edit"
                  onClick={() => {
                    downloadAttachment(byMessageIds[messageIdAuto]);
                  }}
                  text="ダウンロード"
                />
              </td>
            ) : (
              <td />
            )}
          </tr>
        );
      });
    }
    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="messageSortType"
              invalid={invalid}
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
        <Col sm={12} className="text-center">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={getStartEndData}
          />
        </Col>
      </div>
    );
  }
}

export default ReceivedMessageList;
